import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Evidence icon
 *
 * @category Product
 */
const Evidence = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={0.4}
          d="M23.5137 12.001C23.3999 16.5312 19.8102 20.3276 15.1865 20.3281C10.6064 20.2134 6.97261 16.5488 6.8584 12.001C6.8584 7.40175 10.5873 3.67188 15.1865 3.67188C19.7167 3.79599 23.5137 7.37023 23.5137 12.001ZM15.1865 5.17285C11.4157 5.17285 8.3584 8.23018 8.3584 12.001C8.35893 15.7713 11.416 18.8281 15.1865 18.8281C18.9565 18.8276 22.0131 15.771 22.0137 12.001C22.0137 8.2305 18.9569 5.17338 15.1865 5.17285Z"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={0.4}
          d="M7.4668 5.02051C7.63347 5.02052 7.7861 5.02692 7.9248 5.03906C8.04581 5.05 8.09386 5.19536 8.01074 5.28418C7.66222 5.65662 7.34251 6.05634 7.05469 6.47949C7.02897 6.51731 6.98693 6.54157 6.94141 6.5459C4.16158 6.81031 1.98744 9.15096 1.9873 12C1.98755 14.8486 4.16118 17.1882 6.94043 17.4531C6.98588 17.4575 7.02798 17.4818 7.05371 17.5195C7.3418 17.943 7.66258 18.3424 8.01172 18.7148C8.09494 18.8036 8.04686 18.9487 7.92578 18.96C7.78677 18.9727 7.63401 18.9805 7.4668 18.9805L7.10742 18.9707C3.41998 18.7835 0.486584 15.7339 0.486328 12C0.486468 8.14545 3.61227 5.02074 7.4668 5.02051Z"
        />
      </svg>
    );
  }
);

Evidence.displayName = 'Evidence';

export { Evidence };
